import { getSubscriptinsListApiV1CloudpaymentsSubscriptionsGet } from '@/common/api/client/sdk.gen'
import { useQuery } from '@tanstack/react-query'

export const useSubscriptionsList = () => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ['cloudpayments', 'subscriptions'],
        queryFn: () => getSubscriptinsListApiV1CloudpaymentsSubscriptionsGet().then(response => response.data ?? []),
    })

    return {
        subscriptions: data ?? [],
        isLoading,
        error,
        refetch,
    }
}
